import { Link } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { Col } from "react-bootstrap"

const Post = ({ item }) => {
  const path = getImage(item.Image.localFile)

  return (
    <Col lg={3} md={6} xs={6} className="p-items">
      <Link to={`/blog/${item.category}/${item.slug}`}>
        <GatsbyImage image={path} alt={item.title} />
      </Link>
      <Link to={`/blog/${item.category}`}>
        <p className="my-2 cat">{item.category}</p>
      </Link>
      <Link to={`/blog/${item.category}/${item.slug}`}>
        <h1 className="rb">{item.title}</h1>
      </Link>
    </Col>
  )
}

export default Post
